var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_46274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.56219 2.54582L8.03197 13.0433C8.29497 13.6609 9.17476 13.6485 9.42013 13.0236L11.0001 8.99984L15.0238 7.41986C15.6487 7.17449 15.6612 6.2947 15.0435 6.0317L4.54606 1.56195C3.92472 1.29738 3.29763 1.92448 3.56219 2.54582Z",
    fill: "#12131A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7501 22.4999C21.478 22.4999 24.5001 19.4778 24.5001 15.7499C24.5001 12.022 21.478 8.99989 17.7501 8.99989C14.0222 8.99989 11.0001 12.022 11.0001 15.7499C11.0001 19.4778 14.0222 22.4999 17.7501 22.4999Z",
    fill: "#12131A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03197 13.0433L3.56219 2.54582C3.29763 1.92448 3.92472 1.29738 4.54606 1.56195L15.0435 6.0317C15.6612 6.2947 15.6487 7.17449 15.0238 7.41986L11.0001 8.99984L9.42013 13.0236C9.17476 13.6485 8.29497 13.6609 8.03197 13.0433ZM12.7693 6.69366L9.84299 7.84272L8.69392 10.769L5.67187 3.67163L12.7693 6.69366Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7501 12.7499C17.3359 12.7499 17.0001 13.0857 17.0001 13.4999V14.9999H15.5001C15.0859 14.9999 14.7501 15.3357 14.7501 15.7499C14.7501 16.1641 15.0859 16.4999 15.5001 16.4999H17.0001V17.9999C17.0001 18.4141 17.3359 18.7499 17.7501 18.7499C18.1643 18.7499 18.5001 18.4141 18.5001 17.9999V16.4999H20.0001C20.4143 16.4999 20.7501 16.1641 20.7501 15.7499C20.7501 15.3357 20.4143 14.9999 20.0001 14.9999H18.5001V13.4999C18.5001 13.0857 18.1643 12.7499 17.7501 12.7499Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7501 22.4999C21.478 22.4999 24.5001 19.4778 24.5001 15.7499C24.5001 12.022 21.478 8.99989 17.7501 8.99989C14.0222 8.99989 11.0001 12.022 11.0001 15.7499C11.0001 19.4778 14.0222 22.4999 17.7501 22.4999ZM17.7501 20.9999C20.6496 20.9999 23.0001 18.6494 23.0001 15.7499C23.0001 12.8504 20.6496 10.4999 17.7501 10.4999C14.8506 10.4999 12.5001 12.8504 12.5001 15.7499C12.5001 18.6494 14.8506 20.9999 17.7501 20.9999Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_46274",
    x: 0.5,
    y: -0.000244141,
    width: 27,
    height: 27.0002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_46274"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_46274",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorCopy);
export default __webpack_public_path__ + "static/media/cursorCopy.3851b5f69fc4c6037560fffafdaa5ed9.svg";
export { ForwardRef as ReactComponent };